import * as React from "react";
import type { SVGProps } from "react";
import PropTypes from 'prop-types';
/* istanbul ignore file */
interface Props extends SVGProps<SVGSVGElement> {
  srText?: string;
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number;
  alt?: string;
}
function IconLessonsDefault({
  srText,
  size = 'md',
  className = '',
  ...props
}: Props) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" fillRule="evenodd" d="M9.16 6.429a.647.647 0 0 0-.651.642V7.5c0 .394-.345.714-.77.714-.424 0-.769-.32-.769-.714v-.429C6.97 5.947 7.93 5 9.16 5h10.65C21.04 5 22 5.947 22 7.071v6.108c0 1.124-.96 2.071-2.19 2.071h-.502c-.425 0-.77-.32-.77-.714 0-.395.345-.715.77-.715h.503c.338 0 .65-.268.65-.642V7.07a.647.647 0 0 0-.65-.642zM2 11.82c0-1.124.96-2.071 2.19-2.071h10.65c1.23 0 2.19.947 2.19 2.071v6.108c0 1.124-.96 2.071-2.19 2.071H4.19C2.96 20 2 19.053 2 17.929zm2.19-.642a.647.647 0 0 0-.652.642v6.108c0 .374.313.642.651.642H14.84c.339 0 .651-.268.651-.642V11.82a.647.647 0 0 0-.65-.642z" clipRule="evenodd" /></svg></>;
}
IconLessonsDefault.propTypes = ({
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string
} as PropTypes.ValidationMap<Props>);
export default IconLessonsDefault;